import type { NextPage, NextPageContext } from 'next';
import { NextSeo } from 'next-seo';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { checkCookieSearchData, init } from '../../actions/baseActions';
import { searchByHotelIdInElastic } from '../../app/api/hotels';
import Hotels from '../../app/components/Hotels/Hotels';

interface PageProps {
	brandsDescription: string;
	hotelName: string;
}

const HotelsPage: NextPage<PageProps> = (props) => {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	useEffect(() => {
		init('hotels')(dispatch);
		checkCookieSearchData()(dispatch);
	}, []);

	return (
		<div>
			<NextSeo
				title={props.hotelName ? `Compare ${props.hotelName} Hotels` : t('metadata.hotels.title')}
				description={t('metadata.hotels.description')}
				canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/hotels`}
				openGraph={{
					url: `${process.env.NEXT_PUBLIC_SITE_URL}/hotels`,
					title: t('metadata.hotels.title'),
					description: t('metadata.hotels.description'),
					site_name: process.env.NEXT_PUBLIC_SITE_NAME,
				}}
			/>
			<Hotels brandsDescription={props.brandsDescription} hotelName={props.hotelName} />
		</div>
	);
};
HotelsPage.getInitialProps = async (ctx: NextPageContext): Promise<PageProps> => {
	const brandsDescription = ctx.query.bs as string;
	const hid = ctx.query.hid;
	let hotelName = null;
	if (hid) {
		hotelName = await (await searchByHotelIdInElastic(hid.toString()))?.name;
	}
	return { brandsDescription, hotelName };
};
export default HotelsPage;
